module.exports = __webpack_public_path__ + "img/noemi2-logo.d80b5ed4.png";